import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-multiple-error-popover',
  templateUrl: './multiple-error-popover.component.html',
  styleUrls: ['./multiple-error-popover.component.scss'],
  standalone: false,
})
export class MultipleErrorPopoverComponent {
  @Input() description!: string[];

}
